export default "__VITE_PUBLIC_ASSET__fb76f07b__"